import GoogleAnalyticsService from '../../../common/services/analytics/google-analytics.service';
import { Country } from '../../../common/models/country.model';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { CountryChangeAction } from '../../../common/actions/country.action';
import { LanguageChangeAction } from '../../../common/actions/language.action';
import { OpenLoginDialogAction } from '../../../components/login-dialog/login-dialog.action';
import UserService from '../../../common/services/user/user.service';

/* @ngInject */
export default class HeaderController {
  public countries: Country[] = [];
  public availableLanguages = [];
  public country: Country;
  public language: string;

  constructor(
    public config,
    private i18n,
    public userService: UserService,
    private actionDispatcher: ActionDispatcherService,
    private googleAnalytics: GoogleAnalyticsService
  ) { }

  public $onInit() {
    this.countries = this.config.countries;
    this.country = this.countries[0];
    this.availableLanguages = this.i18n.getAvailableLanguages();
    this.language = this.i18n.getCurrentLanguage();
  }

  public onLogin() {
    window.location.href = `${this.config.auth.loginResource}/login?language=` + this.i18n.getCurrentLanguage() + `&redirectUrl=https:%2F%2F${window.location.href.split("/")[2]}%2F`;
  }


  public onCountryChange() {
    this.userService.setTerritory(this.country.territory.toUpperCase());
    this.actionDispatcher.dispatch(new CountryChangeAction(this.country));
  }

  public onLanguageChange = (lang: string) => {
    this.language = lang;
    this.i18n.useLanguage(this.language);
    this.actionDispatcher.dispatch(new LanguageChangeAction(this.language, true));
    this.googleAnalytics.writeVirtualPages({
      language: this.language
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/header/header.controller.ts